"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userAccessReducer = void 0;
const user_access_component_1 = __importDefault(require("./user-access.component"));
const user_access_reducer_1 = __importDefault(require("./user-access.reducer"));
exports.userAccessReducer = user_access_reducer_1.default;
exports.default = user_access_component_1.default;
